module.exports = __webpack_public_path__ + "img/2.3a39603a.png";